import { groupBy } from 'lodash-es';
import { useTranslation } from 'next-i18next';

import { Disclosure } from '@headlessui/react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline';

export function FAQ({ faq }) {
	return (
		<Disclosure
			as="div"
			key={faq.question}
			defaultOpen={false}
			className="pt-6"
		>
			{({ open }) => (
				<>
					<dt>
						<Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
							<h3 className="text-base font-semibold leading-7">
								{faq.question}
							</h3>
							<span className="ml-6 flex h-7 items-center">
								{open ? (
									<MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
								) : (
									<PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
								)}
							</span>
						</Disclosure.Button>
					</dt>
					<Disclosure.Panel as="dd" className="mt-2 pr-12">
						<div
							className="text-base leading-7 text-gray-600"
							dangerouslySetInnerHTML={{ __html: faq.answer }}
						></div>
					</Disclosure.Panel>
				</>
			)}
		</Disclosure>
	);
}

export default function CompanyFAQs({ company, faqs }) {
	const { t } = useTranslation(['common']);
	const topicList = groupBy(faqs, 'topic');
	const topics = Object.keys(topicList);

	return (
		<section id="faq" className="">
			<div className="mx-auto text-center">
				<span className="text-lg font-semibold leading-8 tracking-tight text-blue-600">
					{t('common:faq.overtitle')}
				</span>
				<h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 lg:text-3xl">
					{t('common:faq.title')}
				</h2>
				<p className="mt-4 text-lg text-gray-500">
					{t('common:faq.subtitle', { company: company.name })}
				</p>
			</div>
			<div className="space-y-16 pt-16">
				{topics.map((topic) => (
					<div key={topic}>
						{topic !== 'general' && (
							<h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900">
								{topic}
							</h2>
						)}
						<dl className="mt-4 space-y-6 divide-y divide-gray-900/10">
							{topicList[topic].map((faq) => (
								<FAQ key={faq.id} faq={faq} />
							))}
						</dl>
					</div>
				))}
			</div>
		</section>
	);
}
